jQuery(document).ready(function($) {

    const 
        $nextWeekButton = $( '.' + nextWeeklocalizedData.nextWeekButtonClass + '>a' ),
        buttonNextWeekActiveClass = 'next-week-update-active',
        buttonNextWeekCompleteClass = 'next-week-update-complete',
        buttonNextWeekFailedClass = 'next-week-update-failed'
        ;

    $nextWeekButton.on('click', function(e) {

        e.preventDefault();
        const $this = $(this);

        $this
            .text(nextWeeklocalizedData.loadingText)
            .addClass(buttonNextWeekActiveClass)
            ;

        postAjax( $this );
        
    });

    function postAjax($nextWeekButton) {
        
        $.ajax({
            url: nextWeeklocalizedData.adminAjax,
            type: "POST",
            cache: false,
            data: {
                action: 'update_products_days_cat',
            },
            success: function(res) {
                if (res.success === false) {
                    console.log(res);
                    $nextWeekButton
                        .removeClass(buttonNextWeekActiveClass)
                        .addClass(buttonNextWeekFailedClass)
                        .text(nextWeeklocalizedData.errorText)
                        ;
                }
                else {
                    $nextWeekButton
                        .removeClass(buttonNextWeekActiveClass)
                        .addClass(buttonNextWeekCompleteClass)
                        .text(nextWeeklocalizedData.completeText)
                        ;
                }
            }
        });

    }

});
